import React, { createContext, useContext } from 'react';
import { ClientIdType } from "../types";
export interface ApiConfig {
  baseUrl: string;
  authToken: string;
  clientId?: ClientIdType;
  customFilters?: customFilter
}

export enum ConfigurationKeys {
  getR2DCustomerFacets = "getR2DCustomerFacets",
  getR2DSupplierFacets = "getR2DSupplierFacets",
  getR2DOrdersForSupplier = "getR2DOrdersForSupplier",
  getDispatchCustomerFacets = "getDispatchCustomerFacets",
  getDispatchSupplierFacets = "getDispatchSupplierFacets",
  getDispatchOrdersForSupplier = "getDispatchOrdersForSupplier",
  getDispatchRiderFacets = "getDispatchRiderFacets",
}

export type customFilter = Partial<{
  [key in ConfigurationKeys]: {
    endpoint?: string;
    filters?: {
      [key: string]: any;
    };
  };
}>;

const ApiConfigContext = createContext<ApiConfig | undefined>(undefined);

export interface ApiConfigProviderProps {
  children?: React.ReactNode;
  baseUrl: string;
  authToken: string;
  clientId?: ClientIdType;
  customFilters?: customFilter
}

export const ApiConfigProvider: React.FC<ApiConfigProviderProps> = ({
  children,
  baseUrl,
  authToken,
  clientId,
  customFilters
}) => {
  const config: ApiConfig = {
    baseUrl,
    authToken,
    clientId,
    customFilters
  };

  return (
    <ApiConfigContext.Provider value={config}>
      {children}
    </ApiConfigContext.Provider>
  );
};

export const useApiConfig = (): ApiConfig => {
  const context = useContext(ApiConfigContext);
  if (context === undefined) {
    throw new Error('useApiConfig must be used within an ApiConfigProvider');
  }
  return context;
};

let globalApiConfig: ApiConfig | null = null;

export const setGlobalApiConfig = (config: ApiConfig) => {
  globalApiConfig = config;
};

export const getGlobalApiConfig = (): ApiConfig | null => {
  return globalApiConfig;
};
